export const navigation = [];



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/_nav.ts